(() => {
  // This asset can be included by multiple sections on the same page.
  if (window.catideaProductGalleryLoaded) return;
  window.catideaProductGalleryLoaded = true;

  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized) return;
    const preview = gallery.querySelector('[data-product-preview]');
    const thumbs = [...gallery.querySelectorAll('[data-product-thumb]')];
    const row = gallery.querySelector('.thumbs');
    if (!preview) return;
    gallery.dataset.galleryInitialized = 'true';
    const panels = new Map();
    let activePanel = createPanel([...preview.childNodes]);
    panels.set(thumbs[0], activePanel);

    function createPanel(content, hidden = false) {
      const panel = document.createElement('div');
      panel.className = 'product-gallery-panel';
      panel.hidden = hidden;
      panel.append(...content);
      preview.append(panel);
      return panel;
    }

    function pauseExternalVideo(panel) {
      const iframe = panel.querySelector('iframe');
      if (!iframe) return;
      const url = new URL(iframe.src, document.baseURI);
      const youtube = url.hostname === 'www.youtube.com' || url.hostname === 'www.youtube-nocookie.com';
      iframe.contentWindow?.postMessage(JSON.stringify(youtube
        ? { event: 'command', func: 'pauseVideo', args: [] }
        : { method: 'pause' }), url.origin);
    }

    function initializePanel(panel) {
      panel.galleryModelRequested = false;
      const iframe = panel.querySelector('iframe');
      if (iframe) {
        iframe.addEventListener('load', () => {
          const origin = new URL(iframe.src, document.baseURI).origin;
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'listening' }), origin);
          if (panel !== activePanel) pauseExternalVideo(panel);
        });
      }
      const model = panel.querySelector('model-viewer');
      if (!model || !window.Shopify?.loadFeatures) return;
      window.Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad(errors) {
          if (errors || !model.isConnected || !window.Shopify.ModelViewerUI) return;
          panel.galleryModelUI = new window.Shopify.ModelViewerUI(model);
          if (panel === activePanel && panel.galleryModelRequested) panel.galleryModelUI.play();
        }
      }]);
    }

    function prepareVideo(panel) {
      const video = panel.querySelector('video');
      if (!video || video.dataset.galleryPrepared) return;
      video.dataset.galleryPrepared = 'true';
      video.playsInline = true;
      video.preload = 'metadata';
      // Select sources after a cloned video is connected and visible. Load once
      // so revisiting a paused video never resets its playback position.
      video.load();
    }

    function activateModel(panel) {
      panel.galleryModelRequested = true;
      panel.galleryModelUI?.play();
    }

    function pauseMedia(panel, preservePictureInPicture = false) {
      panel.galleryModelRequested = false;
      panel.querySelectorAll('video').forEach(video => {
        const inPictureInPicture = document.pictureInPictureElement === video ||
          video.webkitPresentationMode === 'picture-in-picture';
        if (!preservePictureInPicture || !inPictureInPicture) video.pause();
      });
      panel.galleryModelUI?.pause();
      pauseExternalVideo(panel);
    }
    // Provider readiness can arrive after a thumbnail click or a quick switch away.
    function onPlayerMessage(event) {
      for (const panel of panels.values()) {
        const iframe = panel.querySelector('iframe');
        if (!iframe || event.source !== iframe.contentWindow ||
            event.origin !== new URL(iframe.src, document.baseURI).origin) continue;
        let data;
        try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; }
        catch { return; }
        if (panel !== activePanel && (data?.event === 'onReady' || data?.event === 'ready')) {
          pauseExternalVideo(panel);
        }
      }
    }
    window.addEventListener('message', onPlayerMessage);
    function onSectionUnload(event) {
      if (!event.target.contains(gallery)) return;
      panels.forEach(panel => {
        pauseMedia(panel);
        panel.galleryModelUI?.destroy();
      });
      window.removeEventListener('message', onPlayerMessage);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);
    initializePanel(activePanel);
    prepareVideo(activePanel);
    thumbs.forEach(button => button.addEventListener('click', () => {
      let panel = panels.get(button);
      if (!panel) {
        const template = button.querySelector('template[data-gallery-media]');
        if (!template) return;
        panel = createPanel([template.content.cloneNode(true)], true);
        panels.set(button, panel);
        initializePanel(panel);
      }
      if (panel !== activePanel) {
        pauseMedia(activePanel, true);
        activePanel.hidden = true;
        activePanel = panel;
        activePanel.hidden = false;
      }
      prepareVideo(activePanel);
      // Videos start only through their player controls.
      if (activePanel.querySelector('model-viewer')) activateModel(activePanel);
      thumbs.forEach(item => {
        item.classList.toggle('active', item === button);
        item.setAttribute('aria-current', item === button ? 'true' : 'false');
      });
    }));
    gallery.querySelectorAll('[data-gallery-scroll]').forEach(button => {
      button.addEventListener('click', () => {
        row?.scrollBy({
          left: Number(button.dataset.galleryScroll) * row.clientWidth,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
